import { observer } from 'mobx-react-lite'
import { Outlet, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { uiStore } from 'shared/store/uiStore'
import { SpinnerLoader } from 'shared/ui'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'
import { useInboxesViewContext } from '../context/inboxesViewContext'

export const InboxPageAccessLayout = observer(() => {
  const { id } = useParams()
  const { currentUser, inboxesViewStore, isManageOrganizationInboxes } = useInboxesViewContext()
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    if (inboxesViewStore.firstLoading) return

    const hasAccess = checkAccess()

    if (!hasAccess) {
      changeRoute()
    } else {
      setLoading(false)
    }
  }, [inboxesViewStore.firstLoading])

  const checkAccess = () => {
    if (isManageOrganizationInboxes) {
      return true
    }

    if (!id) return false

    const inboxId = parseInt(id, 10)
    if (isNaN(inboxId)) return false

    const inbox = inboxesViewStore.getItem(inboxId)
    return inbox && inbox.ownerId === currentUser.id
  }

  const changeRoute = () =>
    uiStore.changeRouteViaVue({
      path: InboxesPath.root,
    })

  if (loading) return <SpinnerLoader ariaLabel={'InboxPageAccessLayout'} />

  return (
    <>
      <Outlet />
    </>
  )
})
